export const DELAY_TIME_INPUT_CONFIRMED = 500 // msec
